import { render } from "./StudentsByGenderSponsor.vue?vue&type=template&id=13577403"
import script from "./StudentsByGenderSponsor.vue?vue&type=script&lang=js"
export * from "./StudentsByGenderSponsor.vue?vue&type=script&lang=js"
script.render = render

export default script